import React, { FC, useContext } from 'react';
import { useWatch } from 'react-hook-form';
import FieldsRow from 'shared/components/FieldsRow';
import { HelpDeskTooltipContext } from 'context/HelpDeskTooltipContext';
import { HelpDeskInputFieldEnum } from 'context/HelpDeskTooltipContext/helpDeskInputFieldEnum';
import {
  MANUAL_SCOPE3_CONSTANTS,
  SCOPE3_EMISSION_UNIT,
} from 'constants/Scope3Constants/manualScope3Categories.constants';
import { getManualEmissionFieldsData } from './manualEmissionLayoutData';
import styles from './manualEmission.module.scss';

interface Scope3ManualEmissionFormProps {
  helpdeskKey: HelpDeskInputFieldEnum;
  readOnly?: boolean;
}

const Scope3ManualEmissionForm: FC<Scope3ManualEmissionFormProps> = ({
  helpdeskKey,
  readOnly,
}) => {
  const { openTooltipModal } = useContext(HelpDeskTooltipContext);
  const handleToolTipOpen = (fieldName: HelpDeskInputFieldEnum) => () =>
    openTooltipModal(fieldName);

  const unit = useWatch({ name: MANUAL_SCOPE3_CONSTANTS.FIELD_UNIT });
  const emissions = useWatch({ name: MANUAL_SCOPE3_CONSTANTS.FIELD_EMISSIONS });
  const hasNumericEmissions =
    emissions !== null && emissions !== undefined && emissions !== '' &&
    !Number.isNaN(Number(emissions));
  const showReportingHint =
    unit === SCOPE3_EMISSION_UNIT.KgCo2e && hasNumericEmissions;
  const reportingTonnes = showReportingHint
    ? Number((Number(emissions) / 1000).toFixed(4))
    : null;

  return (
    <div className={styles.formSection}>
      <FieldsRow
        {...getManualEmissionFieldsData({
          handleToolTipOpen,
          helpdeskKey,
          readOnly,
        })}
      />
      {showReportingHint && (
        <div className={styles.reportingHint}>
          {MANUAL_SCOPE3_CONSTANTS.REPORTING_HINT_PREFIX} {reportingTonnes}{' '}
          {MANUAL_SCOPE3_CONSTANTS.REPORTING_HINT_SUFFIX}
        </div>
      )}
    </div>
  );
};

export default Scope3ManualEmissionForm;
